import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUpgrade = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M9 1.5C4.85455 1.5 1.5 4.85455 1.5 9C1.5 13.1455 4.85455 16.5 9 16.5C13.1455 16.5 16.5 13.1455 16.5 9C16.5 4.85455 13.1455 1.5 9 1.5ZM12.4091 9.00341C12.1416 9.26904 11.7095 9.26795 11.4433 9.00097L9.68182 7.23409V12.4091C9.68182 12.7856 9.37656 13.0909 9 13.0909C8.62344 13.0909 8.31818 12.7856 8.31818 12.4091V7.23409L6.55568 8.99659C6.29021 9.26206 5.85979 9.26206 5.59432 8.99659C5.32885 8.73112 5.32885 8.3007 5.59432 8.03523L8.40717 5.22238C8.73458 4.89497 9.26542 4.89497 9.59284 5.22238L12.4108 8.04034C12.6769 8.30648 12.6762 8.73821 12.4091 9.00341Z",
		fill: "white",
		fillOpacity: .74
	})]
});
const ForwardRef = forwardRef(SvgUpgrade);
export { ForwardRef as ReactComponent };
